<div class="modal-header">
  <h4 class="modal-title">Payment May Still Be Live on the Card Reader</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <app-live-reader-refusal-alert [refusal]="refusal"
                                 alertClass="alert-warning mt-3"
                                 (checked)="onChecked($event)">
  </app-live-reader-refusal-alert>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.dismiss()">
    Cancel
  </button>
  <!-- A check in flight may still succeed, so proceeding then could charge twice. -->
  <button type="button" class="btn btn-primary"
          (click)="handleProceed()"
          [class.disabled]="confirming || refusal.checking"
          [disabled]="confirming || refusal.checking">
    {{ confirming ? 'Loading...' : 'Proceed anyway' }}
  </button>
</div>
